export default {
    LDC: {
        "data": "lignes de caisses",
        "code": "LDC",
        "label": "Lignes De Caisses"
    },
    DAC: {
        "data": "distrib auto carb",
        "code": "DAC",
        "label": "Distributeurs Automatiques de Carburant"
    },
    GUE: {
        "data": "guerite station",
        "code": "GUE",
        "label": "Guérite en station"
    },
    LEX: {
        "data": "livraison express",
        "code": "LEX",
        "label": "Livraison Express"
    },
    RMW: {
        "data": "waa!",
        "code": "RMW",
        "label": "Waa!"
    },
    DRV: {
        "data": "drive",
        "code": "DRV",
        "label": "Drive"
    },
    AUT: {
        "data": "autres",
        "code": "AUT",
        "label": "Autres"
    },
    BIL: {
        "data": "billeterie",
        "code": "BIL",
        "label": "Billeterie"
    },
    TPE: {
        "data": "tpe autonome",
        "code": "TPE",
        "label": "TPE Autonome"
    },
    CFP: {
        "data": "carrefour pay",
        "code": "CFP",
        "label": "Carrefour Pay"
    },
    TRT: {
        "data": "traiteur",
        "code": "TRT",
        "label": "Traiteur"
    },
    GAZ: {
        "data": "gaz",
        "code": "GAZ",
        "label": "Gaz"
    },
    BMS: {
        "data": "borne cadeaux",
        "code": "BMS",
        "label": "Bornes multi-services"
    },
    CLK: {
        "data": "click and collect",
        "code": "CLK",
        "label": "Click and Collect"
    },
    PASS: {
        "data": "pass",
        "code": "PASS",
        "label": "Pass"
    },
    PAY: {
        "data": "payline",
        "code": "PAY",
        "label": "Payline"
    },
    FAV: {
        "data": "foire au vins",
        "code": "FAV",
        "label": "Foire au vins"
    },
}

export const ECOMMERCE_ACTIVITIES = ["Payline", "Drive", "Livraison Express", "Traiteur", "Foire au vins"];


// WEBPACK FOOTER //
// ./src/enums/OperationActivityEnum.js